import { render, staticRenderFns } from "./CouponSelectItem.vue?vue&type=template&id=af43fb6a&scoped=true&"
import script from "./CouponSelectItem.vue?vue&type=script&lang=js&"
export * from "./CouponSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./CouponSelectItem.vue?vue&type=style&index=0&id=af43fb6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af43fb6a",
  null
  
)

export default component.exports